import RejectTable from './Rejected.gql';

export default RejectTable;
